import React from 'react';
import { Box, TextField } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { GroceryFormData } from '../types/Grocery';

interface GroceryFormProps {
  formData: GroceryFormData;
  onChange: (field: keyof GroceryFormData, value: string) => void;
  errors?: Partial<Record<keyof GroceryFormData, string>>;
  compact?: boolean; // For use in tabbed modal where we want fewer fields
}

const GroceryForm: React.FC<GroceryFormProps> = ({ formData, onChange, errors = {}, compact = false }) => {
  return (
    <Box component="form" noValidate autoComplete="off">
      <Grid container spacing={2}>
        {/* Name - full width */}
        <Grid size={12}>
          <TextField
            label="Grocery Name"
            value={formData.name}
            onChange={(e) => onChange('name', e.target.value)}
            fullWidth
            required
            error={!!errors.name}
            helperText={errors.name}
          />
        </Grid>

        {/* Brand / Category */}
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            label="Brand"
            value={formData.brand}
            onChange={(e) => onChange('brand', e.target.value)}
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            label="Category"
            value={formData.category}
            onChange={(e) => onChange('category', e.target.value)}
            fullWidth
            required
            error={!!errors.category}
            helperText={errors.category}
          />
        </Grid>

        {/* Unit / Packaging Size */}
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            label="Unit"
            value={formData.unit}
            onChange={(e) => onChange('unit', e.target.value)}
            fullWidth
            placeholder="e.g., kg, lb, oz, each"
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            label="Packaging Size"
            value={formData.packaging_size}
            onChange={(e) => onChange('packaging_size', e.target.value)}
            fullWidth
            placeholder="e.g., 500g, 1L, 6-pack"
          />
        </Grid>

        {/* Barcode / PLU */}
        <Grid size={12}>
          <TextField
            label="Barcode / PLU (optional)"
            value={formData.barcode}
            onChange={(e) => onChange('barcode', e.target.value)}
            fullWidth
            placeholder="Barcode number or PLU code from produce sticker"
            helperText="The number from product barcode or produce sticker (4-5 digits)"
          />
        </Grid>

        {/* Description - hide in compact mode */}
        {!compact && (
          <Grid size={12}>
            <TextField
              label="Description"
              value={formData.description}
              onChange={(e) => onChange('description', e.target.value)}
              fullWidth
              multiline
              rows={2}
            />
          </Grid>
        )}

        {/* Notes */}
        <Grid size={12}>
          <TextField
            label="Notes"
            value={formData.notes}
            onChange={(e) => onChange('notes', e.target.value)}
            fullWidth
            multiline
            rows={2}
            placeholder="Personal notes about this item..."
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default GroceryForm;